// src/pages/Payment.js
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";
import { CreditCard } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { getData } from "../services/request";

const Payment = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // 1. API Call (GET Request)
  const handlePayment = async () => {
    setLoading(true);
    try {
      const accessToken = localStorage.getItem("accessToken");
      const storedUserData = localStorage.getItem("userData");
      const userData = storedUserData ? JSON.parse(storedUserData) : null;

      if (!accessToken || !userData) {
        setSnackbar({
          open: true,
          message: "Your session has expired. Please log in again.",
          severity: "error",
        });
        navigate("/", { replace: true });
        return;
      }

      // ✅ GET Request
      const response = await getData("/api/user/add_card");

      if (response?.status === true) {
        const authorizationUrl = response?.paystack?.authorization_url;
        if (authorizationUrl) {
          // 🔥 Same tab mein kholen
          window.location.href = authorizationUrl;
          setSnackbar({
            open: true,
            message: "Redirecting to Paystack...",
            severity: "success",
          });
        } else {
          throw new Error("Authorization URL not found");
        }
      } else {
        throw new Error(response?.message || "Payment setup failed");
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        open: true,
        message: error?.message || "Payment setup failed. Please try again.",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  // 2. Success Check (Ab URL seedha /add-bank par aayega)
  useEffect(() => {
    // const currentPath = window.location.pathname;
    const currentPath = "https://dajoo.web.wavepalmapps.com";
    const currentSearch = window.location.search;

    // Agar user /add-bank par hai aur params hain, toh successful payment
    const isPaymentSuccess =
      currentPath.includes("/add-bank") &&
      (currentSearch.includes("reference=") ||
        currentSearch.includes("trxref="));

    if (isPaymentSuccess) {
      setSnackbar({
        open: true,
        message: "Payment Successful!",
        severity: "success",
      });
    }
  }, [navigate]);

  return (
    <Box
      sx={{
        minHeight: "90vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #f5f0ff 0%, #ffffff 100%)",
        // px: 2,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: { xs: "100%", sm: 460 },
          borderRadius: "24px",
          background: "#fff",
          boxShadow: "0px 20px 60px rgba(82, 5, 123, 0.15)",
          p: { xs: 3, sm: 5 },
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            background: "#f3e8ff",
            display: "grid",
            placeItems: "center",
            mx: "auto",
            mb: 3,
          }}
        >
          <CreditCard sx={{ color: "#52057b", fontSize: 36 }} />
        </Box>

        <Typography
          variant="h5"
          sx={{ color: "#52057b", fontWeight: 800, mb: 1 }}
        >
          Payment
        </Typography>
        <Typography variant="body1" sx={{ color: "#666", mb: 3 }}>
          We are setting up your payment verification with Paystack.
        </Typography>

        <Button
          fullWidth
          variant="contained"
          onClick={handlePayment}
          disabled={loading}
          sx={{
            bgcolor: "#52057b",
            color: "#fff",
            py: 1.7,
            borderRadius: "12px",
            fontWeight: 700,
            textTransform: "none",
            boxShadow: "0px 10px 25px rgba(82, 5, 123, 0.3)",
            "&:hover": {
              bgcolor: "#3e055e",
            },
          }}
        >
          {loading ? (
            <CircularProgress size={22} sx={{ color: "#fff" }} />
          ) : (
            "Continue to Payment"
          )}
        </Button>

        <Typography sx={{ color: "#888", fontSize: 12, mt: 3 }}>
          By clicking continue, you will be redirected to Paystack to complete
          your payment securely.
        </Typography>
      </Paper>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity={snackbar.severity}
          sx={{ width: "100%", borderRadius: "12px" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Payment;
